<template>
  <GoogleLogin :params="googleSignInParams" :renderParams="renderParams" :onSuccess="onAuthSuccess" :onFailure="onAuthError">Continue with Google</GoogleLogin>
</template>

<script>
  import GoogleLogin from "vue-google-login";

  export default {
    name: "GoogleAuthBtn",
    components: { GoogleLogin },
    data() {
      return {
        googleSignInParams: {
          client_id: process.env.GOOGLE_OAUTH_APP_ID,
        },
        renderParams: {
          longtitle: true,
          width: "auto",
        },
        recaptchaSiteKey: process.env.GOOGLE_RECAPTCHA_V3_SITE_KEY,
      };
    },
    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
    },
    methods: {
      redirectToDashboard(role) {
        if (role) {
          if (role.indexOf("parent") > -1) {
            this.$router.replace("/parentdashboard");
          }

          if (role.indexOf("child") > -1) {
            this.$router.replace("/childdashboard");
          }
        } else {
          this.$router.replace("/oops");
        }
      },
      authFail(error) {
        this.$store.commit("setError", {
          message: this.$formatter.getErrorMsg(error),
          type: "error",
        });
        delete localStorage.token;
        delete localStorage.role;
      },

      onAuthSuccess(googleUser) {
        const profile = googleUser.getBasicProfile();
        const user = {
          name: profile.getName(),
          email: profile.getEmail(),
          avatar: profile.getImageUrl(),
        };
        const authResponse = googleUser.getAuthResponse(true);

        if (!authResponse.access_token) {
          this.authFail();
          return;
        }
        //store google auth sdk instance
        this.$sdkInstances.setGoogleSDKInstance(gapi.auth2.getAuthInstance());

        // Do google recaptcha check
        grecaptcha.ready(() => {
          grecaptcha
            .execute(this.recaptchaSiteKey, { action: "submit" })
            .then(
              (token) => {
                this.$http
                  .post("/recaptcha/verify", { token: token })
                  .then((response) => {
                    //Send info to backend and store response
                    this.$http
                      .post("/oauth/google", {
                        email: user.email,
                        access_token: authResponse.access_token,
                      })
                      .then((response) => {
                        user.token = response.data.token;
                        user.role = response.data.role;
                        user.lastLogin = this.$datetime.getCurrentTimeInMillisec();
                        this.$store.commit("setUserInfo", user);
                        this.$store.commit("dismissError");
                        localStorage.token = response.data.token;
                        localStorage.role = response.data.role;
                        this.$sessionUser._updateUserInfo(user);
                        this.redirectToDashboard(user.role);
                      })
                      .catch(() => {
                        this.$store.commit("setError", {
                          message: "Could not authenticate with Google, Please try again",
                          type: "error",
                        });
                      });
                  })
                  .catch(() => {
                    this.$store.commit("setError", {
                      message: "Could not authenticate with Google, Please try again",
                      type: "error",
                    });
                  });
              },
              (error) => {
                console.error(error);
                this.$store.commit("setError", {
                  message: "Could not authenticate with Google, Please try again",
                  type: "error",
                });
              }
            )
            .catch((error) => {
              console.error(error);
              this.$store.commit("setError", {
                message: "Could not authenticate with Google, Please try again",
                type: "error",
              });
            });
        });
      },

      onAuthError(error) {
        this.authFail(error);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/GoogleAuthBtn.vue